import { render } from "./TheNavbarComponent.vue?vue&type=template&id=03acb7d8&scoped=true"
import script from "./TheNavbarComponent.vue?vue&type=script&lang=js"
export * from "./TheNavbarComponent.vue?vue&type=script&lang=js"

import "./TheNavbarComponent.vue?vue&type=style&index=0&id=03acb7d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03acb7d8"]])

export default __exports__